"use client"

import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { useRouter, useSearchParams } from 'next/navigation';

interface ActiveFiltersProps {
  params: any;
}

export function ActiveFilters({ params }: ActiveFiltersProps) {
  const router = useRouter();
  const searchParams = useSearchParams();

  const updateParams = (newParams: Record<string, string>) => {
    const params = new URLSearchParams(searchParams);
    
    Object.entries(newParams).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    });
    
    router.push(`/shop?${params.toString()}`);
  };

  const hasActiveFilters = params.category || params.minPrice || params.maxPrice || params.brand || params.size || params.color || params.rating;

  if (!hasActiveFilters) return null;

  return (
    <div className="flex items-center gap-2 mb-6 flex-wrap">
      <span className="text-sm font-medium">Active filters:</span>
      {params.category && (
        <Badge variant="secondary" className="gap-1">
          Category: {params.category}
          <button 
            onClick={() => updateParams({ category: '' })}
            className="ml-1 hover:text-destructive"
          >
            ×
          </button>
        </Badge>
      )}
      {(params.minPrice || params.maxPrice) && (
        <Badge variant="secondary" className="gap-1">
          Price: ₹{params.minPrice || '0'} - ₹{params.maxPrice || '∞'}
          <button 
            onClick={() => updateParams({ minPrice: '', maxPrice: '' })}
            className="ml-1 hover:text-destructive"
          >
            ×
          </button>
        </Badge>
      )}
      {params.brand && (
        <Badge variant="secondary" className="gap-1">
          Brand: {params.brand}
          <button 
            onClick={() => updateParams({ brand: '' })}
            className="ml-1 hover:text-destructive"
          >
            ×
          </button>
        </Badge>
      )}
      <Button 
        variant="ghost" 
        size="sm" 
        onClick={() => router.push('/shop')}
        className="text-muted-foreground hover:text-foreground"
      >
        Clear all
      </Button>
    </div>
  );
} 